
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import BasketItemSpot from './BasketItemSpot/BasketItemSpot.vue'
import QuickOrder from '../QuickOrder/QuickOrder.vue'


export default {
    name: "BasketComponent",
    components: {
        BasketItemSpot,
        QuickOrder
    },
    props:{
        location: {
            type: String,
            default: ''
        }
    },
    setup(props){

        const store = useStore()
        const orderLines = computed(() => store.getters['ecom/getOrderLinesFromCart'])

        const hasItemsInCart = computed(() => !!store.getters['ecom/getOrderLinesFromCart'].length)
        const cartSpinnerSpinning = computed(()=>store.state.ecom.cart_spinner_spinning)

        const modifyCartLayout = (props.location === 'confirm' || props.location === 'receipt')

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        onMounted(() => {
            if(props.location === 'confirm') return false

            store.dispatch('ecom/getCart')
        })

        return {
            hasItemsInCart,
            orderLines,
            modifyCartLayout,
            cartSpinnerSpinning,
            getLabel
        }
    }
}
